import { withInstall } from '@jdesign-vue/utils'

import ImageViewer from './src/image-viewer.vue'

export const JdImageViewer = withInstall(ImageViewer)
export default JdImageViewer

export * from './src/image-viewer'
